@if (showPam()) {
  <bit-nav-item icon="bwi-lock-encrypted" [text]="'pamAccessRequestsTitle' | i18n" route="pam" />
}
